import React, { useMemo } from 'react';
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  type NodeTypes,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { StepNode } from '@/lib/steps/step-node';
import { templateToGraph } from 'src/lib/workflows/templateToGraph';
import type { WorkflowTemplateResponse } from '@erp/rpc';

const nodeTypes: NodeTypes = {
  stepNode: StepNode,
};

interface WorkflowGraphPreviewProps {
  template: WorkflowTemplateResponse;
  height?: string;
}

/**
 * Visual preview of a workflow template's graph structure
 * Uses React Flow to render an interactive node graph
 */
export function WorkflowGraphPreview({
  template,
  height = '400px',
}: WorkflowGraphPreviewProps) {
  const { nodes, edges } = useMemo(() => templateToGraph(template), [template]);

  return (
    <div style={{ height, width: '100%' }} className="rounded-lg border">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView
        attributionPosition="bottom-left"
        proOptions={{ hideAttribution: true }}
        minZoom={0.2}
        maxZoom={2}
        defaultEdgeOptions={{
          animated: true,
        }}
      >
        <Background />
        <Controls />
        <MiniMap />
      </ReactFlow>
    </div>
  );
}
